<template>
  <div class="tab-pane__wrapper">
    <el-table
        :data="couponsList"
        :default-sort = "{prop: 'created_at', order: 'descending'}"
        height="750px"
        empty-text="No coupons had generated yet"
    >
      <el-table-column prop="id" label="ID" width="315"/>

      <el-table-column prop="code" label="Code" width="100"/>

      <el-table-column
          prop="active"
          label="Active"
          :filter-method="tableRowsFilterHandler"
          :filters="[{text: 'Active', value: true }, { text: 'Inactive', value: false }]"
          width="75">

        <template slot-scope="scope">
          <el-tag :type="scope.row.active ? 'success' : 'danger'">
            {{ capitalize(`${ scope.row.active }`) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
          label="Plan group"
          prop="plan_group_id"
          :filter-method="tableRowsFilterHandler"
          :filters="[{ text: 'All', value: null }, { text: 'Dating & Social', value: 1 }, { text: 'XXX & Cams', value: 2 }, { text: 'Listing Locator', value: 3 }, { text: 'Tinder', value: 4 }]"
      >
        <template slot-scope="scope">
          {{ scope.row.plan_group_name ? scope.row.plan_group_name : 'All' }}
        </template>
      </el-table-column>

      <el-table-column
          label="Plan type"
          prop="plan_type_id"
          :filter-method="tableRowsFilterHandler"
          :filters="[{ text: '---', value: null }, { text: 'Regular', value: 1 }, { text: 'Monthly', value: 2 }, { text: 'Ultimate', value: 3 }]"
      >
        <template slot-scope="scope">
          {{ scope.row.plan_type_name ? scope.row.plan_type_name : `---` }}
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="Created At" sortable swidth="200"/>

      <el-table-column prop="expired_at" label="Expired At" sortable width="125"/>

      <el-table-column label="Operations" type="flex" align="center">
        <template slot-scope="scope">
          <el-button @click="editCouponHandler(scope.row.id)" type="primary" icon="mdi mdi-pencil" plain size="mini" style="margin-right: 10px">Edit</el-button>
          <el-popconfirm
              @onConfirm="deleteCouponHandler(scope.row.id)"
              confirmButtonType="danger"
              confirmButtonText='Delete'
              cancelButtonText='Cancel'
              icon="el-icon-info"
              iconColor="red"
              title="Are you sure to delete this coupon?"
          >
            <el-button slot="reference" type="danger" icon="mdi mdi-close" plain size="mini">Delete</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <CouponEditDialog ref="editDialog" v-if="couponId"
        :modal-state="isDialogVisible"
        :coupon-id="couponId"
        @hide-modal="toggleDialogStateHandler"
        form-action="Update"
    />
  </div>
</template>

<script>
  import CouponEditDialog from './CouponEditDialog'
  import discountCoupons from '@/mixins/discountCoupons';

  export default {
    name: 'CouponsHistoryTable',
    mixins: [discountCoupons],
    components: { CouponEditDialog },
    data() {
      return {
        isDialogVisible: false,
        couponId: '',
      }
    },
    methods: {
      tableRowsFilterHandler(value, row, column) {
        return row[column['property']] === value
      },
      toggleDialogStateHandler() {
        this.isDialogVisible = false
      },
      editCouponHandler(id) {
        this.couponId = id
        this.isDialogVisible = true
      },
      deleteCouponHandler(id, index) {
        this.$store.dispatch('discountCoupons/deleteCoupon', id)
        this.$notify.success('Coupon removed')
      }
    },
    beforeCreate() {
      this.$store.dispatch('discountCoupons/getCouponsList')
    }
  }
</script>
